"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

// Static CSS string for dark mode — safe to inject as it contains no user input
const darkModeCSS = `
  @media (prefers-color-scheme: dark) {
    body.global-error { background: #081C40 !important; color: #F0F0F0 !important; }
    .ge-card { background: #0D2B5E !important; border-color: rgba(20, 70, 220, 0.25) !important; }
    .ge-muted { color: #C8C8C8 !important; }
    .ge-digest { background: #001A6B !important; color: #C8C8C8 !important; border-color: rgba(20, 70, 220, 0.25) !important; }
    .ge-link { color: #C8C8C8 !important; }
    .ge-link:hover { color: #F0F0F0 !important; }
  }
`;

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="is">
      <head>
        <style dangerouslySetInnerHTML={{ __html: darkModeCSS }} />
      </head>
      <body
        className="global-error"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          fontFamily: '"Martina Plantijn", Georgia, serif',
          padding: "2rem",
          textAlign: "center",
          background: "#F0F0F0",
          color: "#000000",
          margin: 0,
        }}
      >
        <img
          src="/xd-logo-blue.svg"
          alt="Sjálfstæðisflokkurinn"
          style={{ height: "3rem", width: "auto", marginBottom: "2rem" }}
        />

        <div
          className="ge-card"
          style={{
            background: "white",
            border: "1px solid #C8C8C8",
            padding: "2.5rem 2rem",
            maxWidth: "24rem",
            width: "100%",
          }}
        >
          <h1
            style={{
              fontFamily: '"Martina Plantijn", Georgia, serif',
              fontSize: "1.25rem",
              fontWeight: 700,
              margin: "0 0 0.5rem",
            }}
          >
            Villa kom upp
          </h1>
          <p
            className="ge-muted"
            style={{
              color: "#646464",
              fontSize: "0.875rem",
              margin: "0 0 1.5rem",
              lineHeight: 1.5,
            }}
          >
            Óvænt villa kom upp. Vinsamlegast reyndu aftur eða farðu til baka á
            forsíðu.
          </p>

          {error.digest && (
            <div
              className="ge-digest"
              style={{
                fontSize: "0.75rem",
                fontFamily: '"JetBrains Mono", monospace',
                color: "#646464",
                background: "#F0F0F0",
                border: "1px solid #C8C8C8",
                padding: "0.5rem 0.75rem",
                marginBottom: "1.5rem",
              }}
            >
              Tilvísun: {error.digest}
            </div>
          )}

          <div
            style={{
              display: "flex",
              gap: "0.75rem",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <button
              onClick={() => reset()}
              style={{
                padding: "0.625rem 1.25rem",
                backgroundColor: "#1446DC",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "0.875rem",
                fontWeight: 500,
                fontFamily: "inherit",
              }}
            >
              Reyna aftur
            </button>
            <a
              href="/dashboard"
              className="ge-link"
              style={{
                padding: "0.625rem 1.25rem",
                color: "#646464",
                fontSize: "0.875rem",
                fontWeight: 500,
                textDecoration: "none",
                fontFamily: "inherit",
              }}
            >
              Fara á forsíðu
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
